import { State } from '../hooks/useAppState'
import { Connection } from '../ygdrasil/types/types'

export function canUseConnection(connection: Connection, state: State) {
  return connection.createdBy === state.user._id
}
